import clsx from 'clsx'
import type { PropsWithChildren } from 'react'

import { Icon, type IconProps } from '@fv/client-components'

import { ShipperTooltip } from './ShipperTooltip'

export const Help = ({
  children,
  ...iconProps
}: PropsWithChildren<Partial<Omit<IconProps, 'ref'>>>) => {
  return (
    <ShipperTooltip label={children}>
      <Icon
        {...iconProps}
        className={clsx('text-fv-orange', iconProps.className)}
        icon="question-circle"
      />
    </ShipperTooltip>
  )
}
